
/* injects from baggage-loader */

import React, { Component } from "react";
import PropTypes from "prop-types";
import GameWrapper from '../gameWrapper';

export default class GameWrapperWrapper extends Component {
    render () {
        //console.log("GameWrapperWrapper");
        return <GameWrapper key={this.props.routeParams.gameId} {...this.props} />;
    }
}

GameWrapperWrapper.propTypes = {
    routeParams: PropTypes.object,
    location: PropTypes.object,
    params: PropTypes.object,
    selectorKey: PropTypes.string,
    virtualGameId: PropTypes.number,
    providerId: PropTypes.number
};

